// Tracks the listing ids a visitor (guest or logged-in) has recently opened,
// so the product detail page can show a "Recently Viewed" rail without
// requiring an account or a server-side session.
const KEY = 'cc_recently_viewed';
const MAX_ITEMS = 12;

export function getRecentlyViewedIds() {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(KEY);
    const ids = raw ? JSON.parse(raw) : [];
    return Array.isArray(ids) ? ids : [];
  } catch {
    return [];
  }
}

export function addRecentlyViewed(listingId) {
  if (typeof window === 'undefined' || !listingId) return;
  const existing = getRecentlyViewedIds().filter((id) => id !== listingId);
  const next = [listingId, ...existing].slice(0, MAX_ITEMS);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Storage full/unavailable — recently-viewed is a nice-to-have, fail silently.
  }
}

// Returns the recently viewed ids excluding the listing currently being viewed.
export function getRecentlyViewedExcluding(currentId) {
  return getRecentlyViewedIds().filter((id) => id !== currentId);
}
